import { Clipboard } from '@angular/cdk/clipboard'
import { Component, ErrorHandler, ChangeDetectionStrategy, signal } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'

import { MatDialog } from '@angular/material/dialog'
import { MatSnackBar } from '@angular/material/snack-bar'
import { AineistonLatausVirhe, KirjanpidonAineistonLatausTiedot, VahvistaAineistonLatausRequest, VahvistaAineistonLatausResponse } from '@lemon/core-firebase/model/kirjanpidon-aineisto'
import { FirebaseLemonaid } from 'app/_angular/service/firebase-lemonaid.service'
import { LadataanService } from 'app/_jaettu-angular/service/ladataan.service'
import { LemonTranslationService } from 'app/_jaettu-angular/service/lemon-translation.service'
import { KayttajaService } from '../_angular/service/kayttaja.service'
import { VaihdaKieliDialog, VaihdaKieliDialogData } from '../vaihda-kieli.dialog'

@Component({
  standalone: false,
  templateUrl: './aineiston-lataus.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['../login/login.component.css', './aineiston-lataus.component.css'],
})
export class AineistonLatausComponent {
  /** Taikalinkin token (tunnistautumista ei suoritettu) */
  token: string
  /** Mahdollinen virhe, jos aineistoa ei voida jostain syystä ladata */
  aineistonLatausVirhe: AineistonLatausVirhe
  /** Aineiston lataukseen tarvittavat tiedot (tunnistautuminen suoritettu) */
  aineistonLatausData: KirjanpidonAineistonLatausTiedot
  /** Aineisto kuitattiin ladatuksi */
  readonly aineistoKuitattuLadatuksi = signal(false)

  year = new Date().getFullYear()
  readonly aineistonLatausVirheidenKaannosavaimet: Record<AineistonLatausVirhe, string> = {
    [AineistonLatausVirhe.LADATTU]: 'aineiston-lataus.virhe-aineisto-ladattu',
    [AineistonLatausVirhe.VOIMASSAOLO_PAATTYNYT]: 'aineiston-lataus.virhe-voimassaolo-paattynyt',
  }

  constructor(
    private _kayttajaService: KayttajaService,
    private _firebaseLemonaid: FirebaseLemonaid,
    private _ladataanService: LadataanService,
    private _dialog: MatDialog,
    private _translationService: LemonTranslationService,
    private _clipboard: Clipboard,
    private _snackbar: MatSnackBar,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _errorHandler: ErrorHandler,
  ) {
    this._kayttajaService.logout()

    // 1. Avattu taikalinkki
    this.token = this._activatedRoute.snapshot.params?.token

    // 2. Ohjattu takaisin onnistuneesta tunnistautumisesta
    this.aineistonLatausData = this._router.currentNavigation()?.extras?.state as KirjanpidonAineistonLatausTiedot

    if (!this.token && !this.aineistonLatausData) {
      this._router.navigate(['/'])
    }
  }

  vaihdaKieli() {
    const data: VaihdaKieliDialogData = {
      tallenna: false,
    }
    this._dialog.open(VaihdaKieliDialog, { data: data })
  }

  lataaAineisto(aineistonLatausData: KirjanpidonAineistonLatausTiedot) {
    if (aineistonLatausData.downloadUrl) {
      window.open(this.aineistonLatausData.downloadUrl, '_blank')
    }
  }

  kopioiLeikepoydalle(aineistonLatausData: KirjanpidonAineistonLatausTiedot) {
    if (aineistonLatausData.downloadUrl && this._clipboard.copy(aineistonLatausData.downloadUrl)) {
      this._snackbar.open(this._translationService.lokalisoi('aineiston-lataus.kopioitu-onnistuneesti'), 'OK', { duration: 3000 })
    }
  }

  tunnistauduError(error: AineistonLatausVirhe) {
    this.aineistonLatausVirhe = error
  }

  async kuittaaLadatuksi() {
    try {
      this._ladataanService.aloitaLataaminen()
      const requestData: VahvistaAineistonLatausRequest = {
        aineistonLatausSessionAvain: this.aineistonLatausData.aineistonLatausSessionAvain,
      }
      const response = await this._firebaseLemonaid.functionsCall<VahvistaAineistonLatausRequest, VahvistaAineistonLatausResponse>('vahvistaAineistonLataus', requestData)
      if (response && !response.e) {
        // Aineisto kuitattu ladatuksi
        this.aineistoKuitattuLadatuksi.set(true)
      } else {
        throw Error('Aineiston kuittaus ladatuksi epäonnistui!')
      }
    } catch (err) {
      this._errorHandler.handleError(err)
      this._snackbar.open(this._translationService.lokalisoi('yleiset.tuntematon-virhe'), 'OK', { duration: 5000 })
    } finally {
      this._ladataanService.lopetaLataaminen()
    }
  }
}
